<template>
  <div
    class="app"
    :class="{
      loading: Object.keys(aplicacion).length === 0,
    }"
  >
    <Loader class="app__loader" @setAplicacion="setAplicacion" />
    <Popup />
    <Transition name="slide" mode="out-in">
      <RouterView
        @debug="setDebug"
        v-if="Object.keys(aplicacion).length != 0"
        :aplicacion="aplicacion"
        @producto="setProducto"
        @modelo="setModelo"
        @campo="setCampo"
        @relaciones="setRelaciones"
        @valor="setValor"
        @error="setError"
        @filtro="setFiltro"
        :changes="changes"
      />
    </Transition>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import Popup from '@/components/library/Popup.vue';

export default {
  name: 'App',
  data() {
    return {
      aplicacion: {},
      changes: {},
      pendingSetValor: 0,
      matchRefTimeout: null,
      pendingRelaciones: [],
    };
  },
  components: {
    Loader,
    Popup,
  },
  computed: {
    seleccion() {
      return this.aplicacion.seleccion[this.aplicacion.getProducto().cod][
        this.aplicacion.getProducto().getModelo().cod
      ];
    },
  },
  mounted() {},
  methods: {
    async setAplicacion(aplicacion) {
      this.aplicacion = aplicacion;
      this.setMatchRef();
    },
    setProducto(producto) {
      this.aplicacion.productoSel = producto;
      this.aplicacion.seleccion.producto = producto;
    },
    setModelo(modelo) {
      this.aplicacion.getProducto().modeloSel = modelo;
      this.aplicacion.seleccion.modelo = modelo;
    },
    async setReferencia(referencia) {
      this.aplicacion.getProducto().getModelo().referenciaSel = referencia;
    },
    setCampo(campo) {
      this.aplicacion.getProducto().getModelo().campoSel = campo;
    },
    setFiltro(campo, caracteristica, filtro, valor) {
      this.aplicacion
        .getProducto()
        .getModelo()
        .getCampo(campo)
        .getCaracteristica(caracteristica)
        .getFiltro(filtro).valorSel = valor;
    },
    setDebug(msg) {
      console.log(msg);
    },
    async setError() {},
    async setValor(campo, caracteristica, valor) {
      this.pendingSetValor++;
      try {
        if (this.seleccion[campo][caracteristica] !== valor) {
          this.aplicacion.loading = true;
          console.log(
            '%cApp - setValor() => ' +
              campo +
              ' ' +
              caracteristica +
              ' ' +
              valor,
            'background-color: green; color: white; font-weight: bold;'
          );
          await this.updateValor(campo, caracteristica, valor);
          await this.updateSeleccion(campo, caracteristica, valor);
          await this.setChanges(campo, caracteristica, valor);
          const relaciones = this.aplicacion
            .getProducto()
            .getModelo()
            .getCampo(campo)
            .getCaracteristica(caracteristica).relaciones;
          if (relaciones) {
            this.pendingRelaciones.push(relaciones);
          }
          if (campo == 'referencias' || campo == 'mueble') {
            await this.setRefValues(campo);
          }
        
          if (campo == 'cubetas' && caracteristica == 'cubeta1_tala' && this.aplicacion.getProducto().getModelo().cod == 'A.71') {
            await this.setRefValues('cubetas');
          }

          if (campo == 'mueble' && caracteristica == 'mueble_extra_frame') {
            // Primero actualizamos mueble y luego forzamos la búsqueda de referencias
            await this.setRefValues('mueble');
            await this.setMatchRef();
          }
        }
      } finally {
        this.pendingSetValor--;
        if (campo != 'referencias') {
          this.scheduleSetMatchRef();
        }
      }
    },
    async updateValor(campo, caracteristica, valor) {
      this.aplicacion
        .getProducto()
        .getModelo()
        .getCampo(campo)
        .getCaracteristica(caracteristica).valorSel = valor;
    },
    async updateSeleccion(campo, caracteristica, valor) {
      const producto = this.aplicacion.getProducto();
      const modelo = producto.getModelo();
      this.aplicacion.seleccion[producto.cod][modelo.cod][campo][
        caracteristica
      ] = valor;
    },
    async setChanges(campo, caracteristica, valor) {
      this.changes = { campo, caracteristica, valor };
    },
    async setRelaciones(relaciones) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          for (const relacion of relaciones) {
            const valor = eval(relacion.valor);
            await this.setValor(relacion.campo, relacion.caracteristica, valor);
          }
          resolve();
        }, 0);
      });
    },
    scheduleSetMatchRef() {
      if (this.matchRefTimeout) {
        clearTimeout(this.matchRefTimeout);
      }
      this.matchRefTimeout = setTimeout(async () => {
        if (this.pendingSetValor === 0) {
          await this.setMatchRef();
          if (
            this.seleccion.referencias.modelo === 'personalizado' &&
            this.pendingRelaciones.length > 0
          ) {
            for (const rel of this.pendingRelaciones) {
              await this.setRelaciones(rel);
            }
            this.pendingRelaciones = [];
          }
          this.matchRefTimeout = null;
        }
      }, 50);
    },
    async setMatchRef() {
      // /*HARDCODE*/
      // if (
      //   this.aplicacion.getProducto().modeloSel === 'G.19' &&
      //   this.seleccion.referencias.modelo === '[47]' &&
      //   (this.seleccion.mueble.modelo === 'line' ||
      //     this.seleccion.mueble.modelo === 'drawer' ||
      //     this.seleccion.mueble.modelo === 'frame')
      // ) {
      //   var referencia = 'personalizado';
      //   var referenciaSel =
      //     '[' + this.getLiteral('globals.personalizado') + ']';
      //   console.log('Hardcoding referencias modelo to personalizado');
      //   console.log('REFERENCIA=> ' + referencia);
      //   await this.setReferencia(referenciaSel);
      //   await this.updateValor('referencias', 'modelo', referencia);
      //   await this.setChanges('referencias', 'modelo', referencia);
      //   return;
      // }
      // /*HARDCODE*/

      const estandares = this.aplicacion.getProducto().getModelo().estandares;
      const config = {
        dimx: this.seleccion.lavabo.dimx,
        dimy: this.seleccion.lavabo.dimy,
        dimz: this.seleccion.lavabo.dimz,
        unidades: this.seleccion.cubetas.unidades,
        cubetas_posx: this.seleccion.cubetas.cubetas_posx,
        cubeta1_rep: this.seleccion.cubetas.cubeta1_rep,
        cubeta1_tala: this.seleccion.cubetas.cubeta1_tala,
        cubeta1_dimx: this.seleccion.cubetas.cubeta1_dimx,
        ...(this.seleccion.cubetas.unidades === 2 && {
          cubeta2_rep: this.seleccion.cubetas.cubeta2_rep,
          cubeta2_tala: this.seleccion.cubetas.cubeta2_tala,
          cubeta2_dimx: this.seleccion.cubetas.cubeta2_dimx,
          cubeta2_dist: this.seleccion.cubetas.cubeta2_dist,
        }),
        mueble: this.seleccion.mueble.modelo,
        mueble_extra_frame: this.seleccion.mueble.mueble_extra_frame,
      };

      const match = estandares.find((estandar) =>
        Object.keys(config)
          .filter((key) => key in estandar)
          .every((key) => estandar[key] === config[key])
      );

      var referencia;
      var referenciaSel;

      if (match) {
        if (
          this.seleccion.mueble.modelo === 'drawer' ||
          this.seleccion.mueble.modelo === 'line'
        ) {
          referencia = match.referencia;
          referenciaSel = '[' + this.getLiteral('globals.personalizado') + ']';
        } else {
          referencia = match.referencia;
          referenciaSel = match.referenciaMueble;
        }
      } else {
        referencia = 'personalizado';
        referenciaSel = '[' + this.getLiteral('globals.personalizado') + ']';
      }

      console.log('REFERENCIA=> ' + referencia);
      await this.setReferencia(referenciaSel);
      await this.updateValor('referencias', 'modelo', referencia);
      await this.updateSeleccion('referencias', 'modelo', referencia);
      await this.setChanges('referencias', 'modelo', referencia);
    },
    async setRefValues(campo) {
      const estandares = this.aplicacion.getProducto().getModelo().estandares;
      const referencia = this.seleccion.referencias.modelo;
      const mueble = this.seleccion.mueble.modelo;
      const taladro = this.seleccion.cubetas.cubeta1_tala;

      if (referencia == 'personalizado') {
        return;
      }

      if (campo == 'referencias') {
        // Intenta buscar primero considerando el estado de mueble_extra_frame
        let matchList = estandares.filter(
          (estandarEl) =>
            estandarEl.referencia == referencia &&
            estandarEl.mueble == mueble &&
            estandarEl.mueble_extra_frame === this.seleccion.mueble.mueble_extra_frame
        );

        if (matchList.length === 0) {
          matchList = estandares.filter(
            (estandarEl) =>
              estandarEl.referencia == referencia &&
              estandarEl.mueble == 'sm' &&
              estandarEl.mueble_extra_frame === this.seleccion.mueble.mueble_extra_frame
          );
        }

        // Si no encuentra con el estado actual de frame, busca sin considerar frame
        if (matchList.length === 0) {
          matchList = estandares.filter(
            (estandarEl) =>
              estandarEl.referencia == referencia && estandarEl.mueble == mueble
          );
        }

        if (matchList.length === 0) {
          matchList = estandares.filter(
            (estandarEl) =>
              estandarEl.referencia == referencia && estandarEl.mueble == 'sm'
          );
        }

        let match =
          matchList.length === 1
            ? matchList[0]
            : taladro
              ? matchList.find((el) => el.cubeta1_tala === taladro)
              : matchList[0];

        if (!match) {
          match = estandares.find(
            (estandarEl) =>
              estandarEl.referencia == referencia && estandarEl.mueble == 'sm'
          );
        }

          const keys = [
          'dimx',
          'dimy',
          'dimz',
          'mueble',
          'unidades',
          'cubetas_posx',
          'cubeta1_rep',
          'cubeta1_tala',
          'cubeta1_dimx',
          'cubeta2_rep',
          'cubeta2_tala',
          'cubeta2_dimx',
          'cubeta2_dist',
        ];

        for (const key of keys) {
          if (!Object.prototype.hasOwnProperty.call(match, key)) {
            continue;
          }

          let campo;
          let caracteristica;
          const valor = match[key];

          switch (key) {
            case 'dimx':
            case 'dimy':
            case 'dimz':
              campo = 'lavabo';
              caracteristica = key;
              break;
            case 'mueble':
              campo = key;
              caracteristica = 'modelo';
              break;
            case 'unidades':
            case 'cubetas_posx':
            case 'cubeta1_rep':
            case 'cubeta1_tala':
            case 'cubeta1_dimx':
            case 'cubeta2_rep':
            case 'cubeta2_tala':
            case 'cubeta2_dimx':
            case 'cubeta2_dist':
              campo = 'cubetas';
              caracteristica = key;
              break;
            default:
              continue;
          }

          await this.setValor(campo, caracteristica, valor);
        }
      } else {
        // Buscar un estándar que coincida con la referencia, mueble y configuración de cubetas
        let match = estandares.find(
          (estandarEl) =>
            estandarEl.referencia == referencia &&
            estandarEl.mueble == mueble &&
            estandarEl.mueble_extra_frame === this.seleccion.mueble.mueble_extra_frame &&
            estandarEl.cubeta1_tala === this.seleccion.cubetas.cubeta1_tala &&
            estandarEl.cubeta1_rep === this.seleccion.cubetas.cubeta1_rep &&
            (this.seleccion.cubetas.unidades === 1 ||
              (estandarEl.cubeta2_rep === this.seleccion.cubetas.cubeta2_rep &&
                estandarEl.cubeta2_tala ===
                  this.seleccion.cubetas.cubeta2_tala))
        );

        
        if (!match) {
          match = estandares.find(
            (estandarEl) =>
              estandarEl.referencia == referencia &&
              estandarEl.mueble == mueble &&
              estandarEl.mueble_extra_frame === this.seleccion.mueble.mueble_extra_frame
          );
        }

        
        if (!match) {
          match = estandares.find(
            (estandarEl) =>
              estandarEl.referencia == referencia &&
              estandarEl.mueble == mueble
          );
        }

        if (!match) {
          return;
        }
        const keys = [
          'dimx',
          'dimy',
          'dimz',
          'unidades',
          'cubetas_posx',
          'cubeta1_rep',
          'cubeta1_tala',
          'cubeta1_dimx',
          'cubeta2_rep',
          'cubeta2_tala',
          'cubeta2_dimx',
          'cubeta2_dist',
        ];

        for (const key of keys) {
          if (!Object.prototype.hasOwnProperty.call(match, key)) {
            continue;
          }

          let campo;
          let caracteristica;
          const valor = match[key];

          switch (key) {
            case 'dimx':
            case 'dimy':
            case 'dimz':
              campo = 'lavabo';
              caracteristica = key;
              break;
            case 'unidades':
            case 'cubetas_posx':
            case 'cubeta1_rep':
            case 'cubeta1_tala':
            case 'cubeta1_dimx':
            case 'cubeta2_rep':
            case 'cubeta2_tala':
            case 'cubeta2_dimx':
            case 'cubeta2_dist':
              campo = 'cubetas';
              caracteristica = key;
              break;
            default:
              continue;
          }

          await this.setValor(campo, caracteristica, valor);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.app {
  width: 100dvw;
  height: 100dvh;
  overflow: hidden;

  &__loader {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    transition: 0.35s ease-in-out opacity;
  }

  &.loading {
    & .app__loader {
      opacity: 1;
      transition: 0.35s ease-in-out opacity;
    }
  }
}
</style>
